import { useState } from 'react';
import { Container } from './styled';
import { Charts, ChartFull } from '../../../../../components';
import { GiResize } from "react-icons/gi";

export function Chart({ user, objKey, className }) {

    const [openFullChart, setOpenFullChart] = useState(false);

    const generateChartData = (userData) => {
        if (!userData || !Array.isArray(userData)) return { labels: [], datasets: [] };

        const labels = userData.map(item => item[objKey]);
        const dataValues = userData.map(item => item.total);

        const chartData = {
            labels: labels,
            datasets: [
                {
                    label: 'Atendimentos',
                    data: dataValues,
                    backgroundColor: 'rgba(75, 192, 192, 1)',
                    borderColor: 'rgba(75, 192, 192, 1)',
                    borderWidth: 2,
                    pointBackgroundColor: 'rgba(75, 192, 192, 1)',
                },
            ],
        };

        return chartData;
    };

    return (
        <>
            <Container className={className}>
                <div className='full--'>
                    <span onClick={() => setOpenFullChart(true)}>
                        <GiResize fontSize={'1.75rem'} />
                    </span>
                </div>
                <div className='--chart'>
                    <Charts
                        type='Line'
                        data={generateChartData(user)}
                    />
                </div>
            </Container >
            {(openFullChart) &&
                (<ChartFull
                    onClose={() => setOpenFullChart(false)}
                    dataChart={{
                        type: "Line",
                        data: generateChartData(user),
                    }}
                />)
            }
        </>
    );
}